import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'formik';
import moment from 'moment';
import {parsers} from '@neosvoc/nv-platform-core-common';
import {isNil} from 'lodash';
import messages from '../../../../res/translations/messages';

class DateType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            day: null,
            month: null,
            year: null,
        };

        this.validate = this.validate.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.props.formik.registerField(this.props.id, this);
    }

    componentWillUnmount() {
        this.props.formik.unregisterField(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id) {
            this.props.formik.unregisterField(prevProps.id);
            this.props.formik.registerField(this.props.id, this);
        }
    }

    validate(value) {
        try {
            parsers.date(value, this.props);
        } catch (err) {
            return err.payload;
        }
    }

    handleChange(e) {
        const {formik, id} = this.props;

        this.setState({
            [e.target.dataset.id]: e.target.value,
        }, () => {
            if (this.state.day !== null && this.state.month !== null && this.state.year !== null) {
                formik.setFieldValue(id, `${this.state.year}-${this.state.month.padStart(2, '0')}-${this.state.day.padStart(2, '0')}`);
                formik.setFieldTouched(id, true, false);
            }
        });
    }

    getDays() {
        return Array.from(new Array(31), (value, index) => index + 1);
    }

    getMonths() {
        return Array.from(new Array(12), (value, index) => index + 1);
    }

    getYears(min, max) {
        let minYear = 1900;
        let maxYear = moment().year();
        if (!isNil(min)) {
            minYear = moment(min, 'YYYY-MM-DD').year();
        }
        if (!isNil(max)) {
            maxYear = moment(max, 'YYYY-MM-DD').year();
        }

        const diff = maxYear >= minYear ? maxYear - minYear : 0;
        return Array.from(new Array(diff + 1), (value, index) => index + minYear);
    }

    render() {
        const {id, min, max, required} = this.props;

        return (
            <div className="form-row">
                <div className="col-12 col-sm-3 select">
                    <label htmlFor={`date-${id}_day`}><FormattedMessage {...messages.label.day} /></label>
                    <select className="custom-select" id={`date-${id}_day`} name={`${id}.day`} data-id="day" defaultValue=""
                        onChange={this.handleChange} required={required}>
                        <FormattedMessage {...messages.placeholder.day}>
                            {(formattedMessage) => <option value="" key="day" disabled>{formattedMessage}</option>}
                        </FormattedMessage>
                        {
                            this.getDays().map((day) => <option value={day} key={'day' + day}>{day}</option>)
                        }
                    </select>
                </div>
                <div className="col-12 col-sm-3 select">
                    <label htmlFor={`date-${id}month`}><FormattedMessage {...messages.label.month} /></label>
                    <select className="custom-select" id={`date-${id}_month`} name={`${id}.month`} data-id="month" defaultValue=""
                        onChange={this.handleChange} required={required}>
                        <FormattedMessage {...messages.placeholder.month}>
                            {(formattedMessage) => <option value="" key="month" disabled>{formattedMessage}</option>}
                        </FormattedMessage>
                        {
                            this.getMonths().map((month) => <option value={month} key={'month' + month}>{month}</option>)
                        }
                    </select>
                </div>
                <div className="col-12 col-sm-6 select">
                    <label htmlFor={`date-${id}_year`}><FormattedMessage {...messages.label.year} /></label>
                    <select className="custom-select" id={`date-${id}_year`} name={`${id}.year`} data-id="year" defaultValue=""
                        onChange={this.handleChange} required={required}>
                        <FormattedMessage {...messages.placeholder.year}>
                            {(formattedMessage) => <option value="" key="year" disabled>{formattedMessage}</option>}
                        </FormattedMessage>
                        {
                            this.getYears(min, max).map((year) => <option value={year} key={'year' + year}>{year}</option>)
                        }
                    </select>
                </div>
            </div>
        );
    }
}

export default connect(DateType);
